import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NavigationService} from "../../../navigation.service";
import {INavigationItems, INavigationType} from "../../../navigation.interface";
import {FormBuilder, Validators} from "@angular/forms";
import {DbValidators} from "../../../../../../../shared/validators/DbValidators";

@Component({
    selector: 'db-ecommerce-menu-sidebar-items',
    templateUrl: './ecommerce-menu-sidebar-items.component.html',
    styleUrls: ['./ecommerce-menu-sidebar-items.component.scss'],
    standalone: false
})
export class EcommerceMenuSidebarItemsComponent implements OnInit {
  @Input() types: INavigationType[] = [];
  @Input() allTypeItems: INavigationItems;
  @Input() showCreateCustom = false;

  @Output() addNewMenuItem: EventEmitter<INavigationType> = new EventEmitter<INavigationType>();

  activeType: INavigationType;
  selectedTypeItems: INavigationType[];
  menuItemForm = this._fb.group({
    navigationLabel: [null, [Validators.required, Validators.pattern(/.*\S.*/)]],
    url: [null, [DbValidators.trim, Validators.required]]
  });

  constructor(
    private _fb: FormBuilder,
    private _navigationService: NavigationService,
  ) {
  }

  ngOnInit() {
  }

  setActiveType(type: INavigationType) {
    if (type.type === "custom") {
      this.showCreateCustom = true;
    }
    this.activeType = type;
    this.selectedTypeItems = this.allTypeItems[`${type.type}_${type.object_type}`];
  }

  backToTypes() {
    this.activeType = null;
    this.selectedTypeItems = [];
    this.showCreateCustom = false;
  }

  addCustomItem() {
    const item = {...this.activeType};
    item.url = this.menuItemForm.get('url').value;
    item.title = this.menuItemForm.get('navigationLabel').value;
    this.addNewMenuItem.emit(item);
  }

}
